<template>
    <div class="search-com-box">
    <div class="search-input-box">
        <input class="search-input"
        placeholder="搜索商品"
        v-model="searchValue"
        />
    </div>
    <div class="search-btn" @click="onSearch">搜索</div>
    </div>
</template>
<script>
export default {
    name: "OsearchComponent",
    data () {
        return {
            searchValue: ''
        }
    },
    methods: {
        onRouter (item) {
            this.$router.push(item.pagePath)
        },
        onSearch () {
          this.$emit('search',this.searchValue);
        }
    }
}
</script>
<style lang="scss" scoped>
.search-com-box {
  border: solid 1px #ff3333;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-radius: 5px;
}
.search-com-box,.search-input-box,.search-btn,.search-input {
  height: 39px;
}
.search-btn {
  line-height: 39px;
  width: 58px;
  background-color: #ff3333;
  text-align: center;
  color: #ffffff;
}
.search-input {
  font-size: 13px;
  color: #000000 !important;
  margin-left: 15px;
  border: 0;
  padding: 0;
}
.search-input:focus {
    outline: none;
}
.search-input-box {
  color: #000000;
}

</style>